import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
    >
      <g fill={color} stroke="#758697" fill-rule="nonzero">
        <path
          d="M6.41413989,0.508684944 C6.79285254,0.451323622 7.15562617,0.671447512 7.43420949,0.978704421 C7.76759376,1.34640274 7.99374622,1.86501633 7.99374622,2.39056107 C7.99374622,3.07812577 7.83118741,3.88680325 7.52284518,4.82549052 L7.52284518,4.82549052 L12.3912636,4.79332799 C12.7198177,4.79332757 13.0295486,4.94855517 13.2385907,5.21166917 C13.4557581,5.4850102 13.5431865,5.84522156 13.4799811,6.19342259 L13.4799811,6.19342259 L12.3253149,12.5455323 C12.2746404,12.8242165 12.1336915,13.0652881 11.9359941,13.2360148 C11.7447865,13.401137 11.5002905,13.5 11.2365916,13.5 L11.2365916,13.5 L3.5,13.5 L3.5,5.43502591 C4.10562379,5.32407247 4.6310243,5.10298677 5.01966321,4.77225774 C5.49321752,4.36926629 5.78582487,3.80705179 5.78582487,3.05321102 L5.78582487,3.05321102 L5.78582487,2.08536583 C5.78582487,1.58319948 5.79265406,1.13012146 5.95548718,0.809993843 C6.03982452,0.644187829 6.18674755,0.543113404 6.41413989,0.508684944 Z"
          transform="translate(1 1)"
        />
        <path
          d="M3.5,5.50913673 L3.5,13.5 L1.0525,13.5 C0.904880412,13.5 0.773925263,13.4300213 0.678143586,13.3246703 C0.565947078,13.2012644 0.5,13.0298497 0.5,12.8423465 L0.5,12.8423465 L0.5,6.15765353 C0.5,5.97022319 0.566022153,5.79883478 0.678226199,5.67542061 L0.678226199,5.67542061 L3.5,5.50913673 Z"
          transform="translate(1 1)"
        />
      </g>
    </svg>
  )
}

const PraiseIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} color={fill} />
    </ActionIcon>
  )
}

export default PraiseIcon
